export const CAMPAIGNS_LIST_QUERY_KEY = ["campaigns"];
export const BRIEF_CAMPAIGNS_LIST_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "campaigns",
];

export const VENDOR_BILLING_QUERY_KEY = (influencerId: string) => [
  "vendor",
  influencerId,
  "billing",
];

export const FINANCE_INFLUENCER_QUERY_KEY = (campaignInfluencerId: string) => [
  "finance",
  campaignInfluencerId,
  "influencer",
];

export const BRIEF_DYNAMIC_FACETS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "dynamic-facets",
];
export const BRIEF_CAMPAIGN_DYNAMIC_FACETS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "campaign-dynamic-facets",
];

export const BRIEF_CAMPAIGN_FACETS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "campaign-facets",
];

export const PAYOUTS_QUERY_KEY = () => ["payouts"];
export const PAYOUTS_FACETS_QUERY_KEY = () => ["payouts", "facets"];
export const PAYOUT_EXPORTS_QUERY_KEY = () => ["payouts", "bank-verification-exports"];

export const BRIEF_CAMPAIGN_INFLUENCERS_FACETS_QUERY_KEY = (
  briefId: string
) => ["brief", briefId, "campaign-influencers-facets"];

export const BRIEF_CAMPAIGN_PENDING_REVIEW_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "campaign-pending-review",
];

export const BRIEF_CAMPAIGN_INFLUENCER_QUERY_KEY = (
  campaignInfluencerId?: string,
  briefInfluencerId?: string
) => [
  "brief",
  "campaign-influencer",
  {
    campaignInfluencerId: campaignInfluencerId || "",
    briefInfluencerId: briefInfluencerId || "",
  },
];

export const ALTERATION_PREREQUISITES_QUERY_KEY = ["alteration-prerequisites"];